import store from "@/store/store";
import {getQuery, postQuery, putQuery} from "@/modules/common/utils";
import httpServiceV3 from "@/modules/common/services/httpServiceV3";
import paginationUtil from "@/modules/common/utils/paginationUtil";
import {toPaymentPlanBody, toPaymentPlanParams, toScheduledPaymentsRule} from "@/modules/payments/utils/paymentPlanUtil";

const v1Route = '/business/payments/v1/scheduled_payments_rules';
// httpServiceV3's baseURL is the gateway host plus /v3/, and axios concatenates - so only the
// path below that is given here
const v3Route = 'sales/payment_plans';

const LINKED_PAYMENT_PLANS_FEATURE = 'rollout.payments.payables_linked_payment_plans';

// v3 payment_plans replaces v1 scheduled_payments_rules while this flag rolls out. Both branches
// return the v1 shape, so the stores and views are unaware of which one served them.
// TODO: (VCITA2-15351 - flag cleanup): keep only the v3 branch of every method below.
const usePaymentPlansV3 = () => store.getters.hasFeature(LINKED_PAYMENT_PLANS_FEATURE);

const asRule = (plan) => ({scheduled_payments_rule: toScheduledPaymentsRule(plan)});

const createScheduledPayment = async (params) => {
  if (usePaymentPlansV3()) {
    return httpServiceV3.post(v3Route, toPaymentPlanBody(params.scheduled_payments_rule)).then((res) => asRule(res.data))
  }
  params.new_api = true
  return postQuery(v1Route, params).then((res) => res.data)
};

const editScheduledPayment = async (uid, params) => {
  if (usePaymentPlansV3()) {
    return httpServiceV3.patch(`${v3Route}/${uid}`, toPaymentPlanBody(params.scheduled_payments_rule)).then((res) => asRule(res.data))
  }
  params.new_api = true
  return putQuery(`${v1Route}/${uid}`, params).then((res) => res.data)
};

const getScheduledPayments = async (scheduledPaymentsUid) => {
  if (usePaymentPlansV3()) {
    return httpServiceV3.get(`${v3Route}/${scheduledPaymentsUid}`).then((res) => asRule(res.data))
  }
  return getQuery(`${v1Route}/${scheduledPaymentsUid}`, {new_api: true}).then((res) => res.data)
}

const getFilteredScheduledPayments = async (params) => {
  if (usePaymentPlansV3()) {
    return httpServiceV3.get(v3Route, toPaymentPlanParams(params))
      .then((res) => ({scheduled_payments_rules: res.data.payment_plans.map(toScheduledPaymentsRule)}))
  }
  return getQuery(v1Route, {...params, new_api: true}).then((res) => res.data)
}

// Every plan a matter already holds, so a caller can tell which payment requests are spoken for.
// Paged rather than read in one go because the server refuses a per_page above 100 outright.
const fetchActivePlans = async (matterUid) => {
  const fetchPageFn = async (params) => {
    const response = await getFilteredScheduledPayments(params);
    return response?.scheduled_payments_rules || [];
  };
  return paginationUtil.fetchAllPages(fetchPageFn, {
    'filter[engagement_uid]': matterUid,
    status: 'active',
    per_page: 100,
  });
};

export default {
  createScheduledPayment,
  fetchActivePlans,
  editScheduledPayment,
  getScheduledPayments,
  getFilteredScheduledPayments,
}


